module.exports = __webpack_public_path__ + "static/media/loi.adf888e8.jpg";